import { render } from "./SegmentsTabView.vue?vue&type=template&id=11fa5c78"
import script from "./SegmentsTabView.vue?vue&type=script&lang=js"
export * from "./SegmentsTabView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__